export default __webpack_public_path__ + "static/media/88mph.abf53bb5.svg";